import React from "react";
import styles from "./NatureBluePrint.module.css";
// import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const NatureInnovation = () => {
// const navigate = useNavigate();

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.LeftSection}>
          <img src="Images/section-circle-img.webp" alt="young, athletic woman looking into the distance" loading="lazy" decoding="async" />
        </div>
        <div className={styles.RightSection}>

          <div className={styles.content}>
            <img src="Images/VifilconC-logo.webp" alt="Bruno Vision Care vifilcon C hydrogel delivery system logo" loading="lazy" decoding="async" />
            <p> vifilcon C  is a first-of-its-kind enriched proprietary hydrogel contact lens material that uses a unique mechanism for the controlled release of natural substances directly to the eye called Lachryceuticals®</p>
          </div>
          <div className={styles.content}>
            <img src="Images/FusionTechnology-logo.webp" alt="Bruno Vision Care FusionTechnology™ Lachryceuticals® natural  substances horizontal logo"  className={styles.FusionTechnologyLogo} loading="lazy" decoding="async" />
            <p>The FusionTechnology® patented delivery system gradually releases natural polymers Hyaluronic Acid (HA), and Tamarind Seed Polysaccharide (TSP®), which mimic human tears.</p>
            <p>During manufacturing,  Lachryceuticals® are embedded into the vifilcon C hydrogel. When worn, patented FusionTechnology™ gradually releases these natural bio‑copolymers to the eye, delivering lasting hydration and all‑day comfort.</p>
          </div>
          <div className={styles.content}>
 <Link 
  to="/fusion-technology" 
  className={styles.learnMoreText}
>
  LEARN MORE About FusionTechnology™
</Link>
          </div>

        </div>

      </div>
      <div className={styles.RightshapeImg}>
        <img src="Images/RightShapeImg.png" alt="RightShapeImg" loading="lazy" decoding="async" />
      </div>
    </div>
  );
};

export default NatureInnovation;
